const directionMap = {
  right: 0, // angles start pointing to the right and...
  top: 90, // ...go counter clockwise
  left: 180,
  bottom: 270
}

const directionMultipliers = {
  0: [1, 0],
  90: [0, -1],
  180: [-1, 0],
  270: [0, 1]
}

const parallaxes = Array.prototype.map.call(document.getElementsByClassName('parallax'), element => {
  let {angle, movement, speed} = element.dataset
  let multipliers


  // angle has shorthands "top", "left", "bottom" and "right"
  angle = directionMap[angle] ?? parseFloat(angle) // nullish coalescing. using `||` here would fail for `0`
  movement = parseFloat(movement)
  speed = parseFloat(speed)

  // fallback if undefined
  // NaN is the only value that doesn't equal itself
  if (angle !== angle) angle = 270 // move to bottom (default parallax effect)
  if (movement !== movement) movement = 100 // 100px
  if (speed !== speed) speed = 1 // 1

  // check if angle is located in top half and/or left half
  angle %= 360
  if (angle < 0) angle += 360
  const toLeft = angle > 90 && angle < 270
  const toTop = angle < 180

  // align elements at right corner of parent .visual
  element.style[toLeft ? 'left' : 'right'] = 0
  element.style[toTop ? 'top' : 'bottom'] = 0

  // if it's not a perfectly horizontal or vertical movement, get cos and sin
  if (angle % 90) {
    const radians = angle * Math.PI / 180
    multipliers = [Math.cos(radians), Math.sin(radians) * -1] // only sin has to be inverted
  } else multipliers = directionMultipliers[angle]

  return {
    element,
    movement,
    multipliers,
    speed
  }
})

const windowInnerHeight = window.innerHeight

const scrollHandler = (() => {
  const ret = {active: false}
  let timeout

  ret.activate = function activate() {
    if (ret.active) clearTimeout(timeout)
    else {
      ret.active = true
      requestAnimationFrame(runParallax)
    }
    timeout = setTimeout(() => ret.active = false, 20)
  }

  return ret
})()

const runParallax = () => {
  Array.prototype.forEach.call(parallaxes, parallax => {
    const {element, movement, multipliers, speed} = parallax

    const {top, height} = element.getBoundingClientRect()
    const scrolledInContainer = windowInnerHeight - top
    const scrollArea = windowInnerHeight + height
    const progress = scrolledInContainer / scrollArea

    if (progress > -0.1 && progress < 1.1) {
      const position = Math.min(Math.max(progress, 0), 1) * movement
      element.style.transform = `translate3d(${position * multipliers[0] * speed}px, ${position * multipliers[1] * speed}px, 0)`
    }
  })

  if (scrollHandler.active) requestAnimationFrame(runParallax)
}

runParallax()

window.addEventListener('scroll', scrollHandler.activate)
window.addEventListener("load", (event) => reportWindowSize());


function reportWindowSize() {
  const leaf = document.querySelector('.leaf');
  leaf.style.height = "";
  var body = document.body;
  var html = document.documentElement;
  var height_leaf = Math.max(body.scrollHeight,
  html.clientHeight, html.offsetHeight);
  leaf.style.height = height_leaf + "px";
  leaf.classList.add('active');
}